import { useState } from "react";
import Button from "../../../../components/Button";
import { useIsMobile } from "../../../../helpers/ui";
import { colors } from "../../../../styles";
import { Card } from "../Account/components";
import { useStoreActions, useStoreState } from "../../../../store";

const SelectAmount = () => {
  const [amount, setAmount] = useState("");
  const [displayAmount, setDisplayAmount] = useState("$");
  const transferState = useStoreState((state) => state.transfer);
  const transferActions = useStoreActions((actions) => actions.transfer);
  const isMobile = useIsMobile();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    const onlyNums = value.replace(/[^\d.]/g, "");
    setAmount(onlyNums);
    setDisplayAmount(`$${onlyNums}`);
  };

  const handleClick = () => {
    transferActions.setAmount(amount);
    transferActions.setCurrentStep(transferState.nextStep);
  };

  return (
    <Card
      hideStyleOnMobile
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        ...(isMobile && { margin: "60px 0 0 0" }),
        ...(!isMobile && { height: "420px", minHeight: "420px" }),
      }}
    >
      <div className="flex-1"></div>
      <input
        autoFocus
        value={displayAmount}
        onChange={handleChange}
        style={{
          flex: 1,
          border: 0,
          borderBottom: isMobile ? "none" : `1px solid ${colors.black}`,
          fontSize: 64,
          height: 92,
          maxHeight: 92,
          fontWeight: "bold",
          maxWidth: "300px",
          textAlign: "center",
          outline: "none",
        }}
      />
      <div
        style={{
          display: "flex",
          flex: 1,
          width: "100%",
          alignItems: "flex-end",
        }}
      >
        <Button onClick={handleClick}>Review Deposit</Button>
      </div>
    </Card>
  );
};

export default SelectAmount;
